import { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { SCANNERS } from "../../data/content";
import { BrandLabel, renderBrandPhrases } from "./BrandLabel";

const ScannerDetailContext = createContext({ openDetail: () => {} });

export const useScannerDetail = () => useContext(ScannerDetailContext);

export const ScannerDetailProvider = ({ children }) => {
  const [openKey, setOpenKey] = useState(null);
  const s = SCANNERS.find((x) => x.key === openKey);

  return (
    <ScannerDetailContext.Provider value={{ openDetail: setOpenKey }}>
      {children}

      <Dialog open={!!s} onOpenChange={(o) => !o && setOpenKey(null)}>
        <DialogContent
          data-testid={s ? `detail-modal-${s.key}` : "detail-modal"}
          className="max-w-lg rounded-3xl border-line p-0 overflow-hidden gap-0"
        >
          {s && s.detail && (
            <>
              <div className="px-7 pt-8 pb-6" style={{ backgroundColor: s.bg }}>
                <span
                  className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold"
                  style={{ backgroundColor: "#ffffff", color: s.text }}
                >
                  <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.accent }} />
                  {s.short}
                </span>
                <DialogHeader className="mt-4 space-y-1 text-left">
                  <DialogTitle className="text-2xl font-bold tracking-tight text-ink">
                    <BrandLabel text={s.name} />
                  </DialogTitle>
                </DialogHeader>
                {s.detail.heading && (
                  <p className="mt-1 text-base font-semibold" style={{ color: s.text }}>
                    {s.detail.heading}
                  </p>
                )}
              </div>

              <div className="px-7 py-6">
                <p className="text-[15px] leading-relaxed text-slate">{renderBrandPhrases(s.detail.body)}</p>

                <p className="mt-6 text-xs font-semibold uppercase tracking-[0.15em] text-slate">
                  Key features
                </p>
                <ul className="mt-3 space-y-3">
                  {s.detail.features.map((f, i) => (
                    <li key={i} className="flex gap-3 text-[15px] text-ink/80">
                      <span
                        className="mt-1 flex h-4 w-4 flex-none items-center justify-center rounded-full"
                        style={{ backgroundColor: s.accent }}
                      >
                        <svg viewBox="0 0 12 12" className="h-2.5 w-2.5" fill="none">
                          <path d="M2.5 6.2l2 2 4.5-4.6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </ScannerDetailContext.Provider>
  );
};
